export default {
  getStartedForPrice: {
    en: 'Try first month for {price}',
  },
}
